"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Loading;

var _jquery = _interopRequireDefault(require("jquery"));

function Loading() {
  var outer = (0, _jquery.default)('<div>', {
    class: 'mainLoading mainLoading-grow'
  });

  for (var i = 1; i <= 3; i++) {
    var inner = (0, _jquery.default)('<div>', {
      class: "mainLoadingDot dot-" + i
    });
    outer.append(inner);
  }

  return outer.get(0);
}

module.exports = exports.default;